import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const useNotifier = () => {
  // Enhanced configuration for better UI
  const defaultConfig = {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light", // or "dark", "colored"
  };

  const successNotification = (message, options = {}) => {
    toast.success(message, {
      ...defaultConfig,
      ...options,
      className: 'toast-success-custom',
      progressClassName: 'toast-progress-success',
    });
  };

  const errorNotification = (message, options = {}) => {
    console.log("Error notification:", message);
    toast.error(message, {
      ...defaultConfig,
      autoClose: 5000, // Errors stay slightly longer
      ...options,
      className: 'toast-error-custom',
      progressClassName: 'toast-progress-error',
    });
  };

  const infoNotification = (message, options = {}) => {
    toast.info(message, {
      ...defaultConfig,
      ...options,
      className: 'toast-info-custom',
      progressClassName: 'toast-progress-info',
    });
  };

  const warningNotification = (message, options = {}) => {
    toast.warning(message, {
      ...defaultConfig,
      ...options,
      className: 'toast-warning-custom',
      progressClassName: 'toast-progress-warning',
    });
  };

  // Custom notification with icon
  const customNotification = (message, type = 'default', icon = null, options = {}) => {
    const config = {
      ...defaultConfig,
      ...options,
      icon: icon,
    };

    switch (type) {
      case 'success':
        return toast.success(message, config);
      case 'error':
        return toast.error(message, config);
      case 'info':
        return toast.info(message, config);
      case 'warning':
        return toast.warning(message, config);
      default:
        return toast(message, config);
    }
  };

  // Promise notification for async operations
  const promiseNotification = (promise, messages = {}) => {
    return toast.promise(
      promise,
      {
        pending: messages.pending || 'Loading...',
        success: messages.success || 'Success! 👍',
        error: messages.error || 'Something went wrong 😢',
      },
      defaultConfig
    );
  };

  return {
    successNotification,
    errorNotification,
    infoNotification,
    warningNotification,
    customNotification,
    promiseNotification,
  };
};

export default useNotifier;

// Custom CSS to add to your global styles or component
// Add this to your global CSS file (e.g., globals.css or App.css)

/*

*/